import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { languages, defaultLocale } from './lang/index.js'

Vue.use(VueI18n)

const init = (store) => {
    if (!Vue.prototype._i18n) {
        Vue.prototype._i18n = new VueI18n({
            locale: store.getters['language/appLanguage'],
            fallbackLocale: defaultLocale,
            messages: languages,
            silentTranslationWarn: true
        });
    }
    return Vue.prototype._i18n
}

export { init }